import { capitalize, chain, escapeRegExp } from "lodash"

// The difference with lodash startCase is it will keep special characters such as %
export const titleCase = string => chain(string)
  .split(" ")
  .map(capitalize)
  .join(" ")
  .value()

export function createEscapedRegExp(value, { caseInsensitive = true } = {}) {
  let options = "g"

  if (caseInsensitive) {
    options += "i"
  }

  return new RegExp(escapeRegExp(value), options)
}

export function createMatch(searchValue) {
  const matcher = createEscapedRegExp(searchValue)

  return (value) => {
    if (value && value.match(matcher)) {
      return true
    }

    return false
  }
}

/**
 * Safely removes HTML tags and decodes HTML entities from a string
 * Uses DOMParser for secure HTML parsing without script execution risks
 * @param {string} html - The HTML string to sanitize
 * @returns {string} - The plain text content
 */
export function stripHtml(html) {
  if (typeof html !== "string") {
    return html
  }

  try {
    // Use DOMParser for safer HTML parsing (no script execution)
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, "text/html")

    return doc.body.textContent || doc.body.innerText || ""
  } catch {
    return html.replace(/<[^>]*>/g, "")
  }
}
